import Image from 'next/image';
import { useRouter } from 'next/router';
import helpIcon from '@/public/icons/help.svg';
import accountIcon from '@/public/icons/account.svg';
import aboutIcon from '@/public/icons/menu/about.svg';
import chevronRightIcon from '@/public/icons/menu/chevron-right.svg';
import LinkItem from '../LinkItem';
import { SettingsProps } from '../types';
import { useCustomerContext } from '@/lib/customer/CustomerContext';
import i18n from '@/settings/i18n';
import settings from '@/settings';
import {
  getCurrentCountry,
  mapLocaleToLanguage,
} from '../../ExtendedNavbar/TopNavbar/StoreSelector/constants';

const t = i18n.init('shared');

const Settings = ({ closeMenu, onCountryClick }: SettingsProps) => {
  const { customer } = useCustomerContext();
  const router = useRouter();
  const selectedStore = getCurrentCountry(settings.store);
  const language = mapLocaleToLanguage(
    (router.locale || 'en') as 'fr' | 'de' | 'es' | 'en',
  );

  return (
    <section className="pt-2">
      <h2 className="flex h-10 items-center p-5 text-base font-bold">
        {t`Help & Settings`}
      </h2>
      <div>
        <LinkItem
          title={t`Help`}
          handle="/help"
          icon={helpIcon}
          closeMenu={closeMenu}
        />
        <LinkItem
          title={t`About`}
          handle="/about-us"
          icon={aboutIcon}
          closeMenu={closeMenu}
        />
        <LinkItem
          title={customer ? t`Account` : t`Sign In`}
          handle={customer ? '/account/orders' : '/account/login'}
          icon={accountIcon}
          closeMenu={closeMenu}
        />
        {selectedStore != null && (
          <button
            type="button"
            onClick={onCountryClick}
            className="flex w-full items-center justify-between px-6 py-2 text-left outline-none transition duration-150 ease-in-out hover:bg-gray-300"
          >
            <span className="flex items-center gap-x-2">
              <span className="flex h-5 w-5 shrink-0 items-center">
                <Image
                  src={selectedStore.flag}
                  alt={selectedStore.country}
                  width={24}
                  height={24}
                  className="h-full w-full object-contain"
                />
              </span>
              {language}
            </span>
            <span className="h-[15px] w-[15px]">
              <Image
                src={chevronRightIcon}
                height={14}
                width={14}
                alt="Expand"
                className="h-full w-full"
              />
            </span>
          </button>
        )}
      </div>
    </section>
  );
};

export default Settings;
